import defaultEventBanner from '@/images/default-event-banner.jpg'

/** Fallback when an event has no custom `illustrationLink` (details + registration). */
export const DEFAULT_EVENT_BANNER = defaultEventBanner

export const hasCustomEventBanner = (competition) => Boolean(competition?.illustrationLink)

/** Cover URL for event hero / registration banner. */
export const getEventBannerUrl = (competition) => competition?.illustrationLink || DEFAULT_EVENT_BANNER
